export default "__VITE_ASSET__qLEcp0Nr__"